import {ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from "../services/auth.service";
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { IFormBuilder, IFormGroup } from '@rxweb/types';

interface LoginForm {
  email: string | null;
  password: string | null;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {

  companyName: string;
  // Uses a typed version of FormBuilder / FormGroup to reduce chances of making mistakes.
  formBuilder: IFormBuilder;
  loginFormGroup: IFormGroup<LoginForm>;

  constructor(
    formBuilder: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute)
     {
      this.formBuilder = formBuilder;
     }



  ngOnInit(): void {
    this.companyName = this.route.snapshot.params.ondernemingNaam;

    this.loginFormGroup = this.formBuilder.group<LoginForm>({
      email: this.formBuilder.control(null, [Validators.required, Validators.email]),
      password: this.formBuilder.control(null, [Validators.required, Validators.minLength(6)]),
    });
  }

  login()
  {
    if (this.loginFormGroup.valid) {
      const { email, password } = this.loginFormGroup.value;

      this.authService.signIn(email, password);
    }
  }
}
